import { Component } from '@angular/core';

@Component({
  selector: 'bkui-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent { }
